// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__aAUUC","summary":"CartItem_summary__DhpH9","price":"CartItem_price__TwMrW","amount":"CartItem_amount__rOfDv","actions":"CartItem_actions__-Bej9"};